import { createSlice } from "@reduxjs/toolkit";
import {
  getComment,
  getReplyComment,
  getLatestComment,
  createComment,
  createReplyComment,
  getUpdatedComment,
  getUpdateRepliedComment,
} from "../3- actions/comments";
// import { reset } from "../3- actions/novels";
export const counterSlice = createSlice({
  name: "comments",
  initialState: {
    report: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    // builder.addCase(createComment.fulfilled, (state, action) => {
    //   state.userComments = {
    //     ...state.userComments,
    //     comments: [action.payload, ...state.userComments.comments],
    //   };
    // });
  },
});

export default counterSlice.reducer;
